import numbro from 'numbro'
import { format } from 'date-fns'

numbro.setDefaults({
  thousandSeparated: true
})

export default {
  methods: {
    percent (value) {
      if (!value || isNaN(value)) {
        return ''
      }
      return numbro(value / 100.0)
        .format({
          output: 'percent',
          mantissa: 2
        })
    },

    currency (value) {
      return value && numbro(value)
        .formatCurrency({
          mantissa: 2
        })
    },

    currency_avg (value) {
      return value && numbro(value)
        .formatCurrency({
          average: true,
          totalLength: 3
        })
    },

    rounded_number (value) {
      return value && numbro(value)
        .format({
          mantissa: 2
        })
    },

    whole_number (value) {
      return value && numbro(Math.round(value))
        .format()
    },

    ordinal (value) {
      return value && numbro(value)
        .format({
          output: 'ordinal'
        })
    },

    date (value) {
      if (!value) return
      value = value instanceof Date ? value : new Date(value)

      return value.toLocaleDateString()
    },

    dateTime (value) {
      if (!value) return
      value = value instanceof Date ? value : new Date(value)

      return `${value.toLocaleDateString()} ${value.toLocaleTimeString()}`
    },

    dateVerbose (date) {
      return date && format(date, 'MMMM Do YYYY')
    },

    dateTimeVerbose (date) {
      return date && format(date, 'MMMM Do YYYY, h:mm:ss a')
    }

    // truncate (value, length) {
    //   return value.length > length ? value.substr(0, length) + '...' : value
    // }

    // currency_no_sign (value, length) {
    //   return numbro(value).formatCurrency('( 0,0.0a')
    // }
  }
}
